@if (ownChats !== null) {
  <div class="flex flex-col">
    <!-- Empty Messages -->
    @if (ownChats.chats.length === 0) {
      <div class="flex flex-col items-center justify-center">
        <img class="mx-16 mt-16  md:w-96 md:h-auto" src="assets/images/404.svg" alt="404-Logo">
        <span
          class="mx-[84px] mt-8 font-medium text-base text-[#A7A7A7] text-center">Bisher noch ziemlich<br>leer hier.</span>
        </div>
      }
      <!-- Has Messages -->
      @if (ownChats.chats.length > 0) {
        <div class="flex flex-col">
          <!-- Titel -->
          <span class="hidden md:flex md:text-xl md:text-kaz-black md:font-semibold md:mb-7">Nachrichten</span>
          <!-- MessageCard -->
          <div class="flex md:grid md:grid-cols-[40%_1fr] md:bg-[#FAFAFA] md:w-full md:h-[486px] md:rounded-[8px] md:border md:border-[#D2D2D2] md:overflow-hidden">
            <!-- Message-List -->
            <div class="flex flex-col w-full md:max-h-[486px] md:overflow-y-auto md:border-r md:border-[#D2D2D2]">
              @for (chat of ownChats.chats; track chat) {
                <div>
                  <kaz-card-chat (click)="setActiveChat(chat)" [active]="activeChat" [chat]="chat"></kaz-card-chat>
                </div>
              }
            </div>
            <!-- Chat-History-Desktop-->
            <div class="hidden md:relative md:flex">
              <!-- Chat-History -->
              <div #chatHistory class="flex flex-col gap-5 h-full w-full bg-[#FAFAFA] pb-[80px] p-4 overflow-y-auto md:max-h-[486px]">
                @for (msg of messages; track msg) {
                  <div>
                    @if (isOwnMsg(msg.senderUserId)) {
                      <div class="flex justify-end">
                        <span class="flex py-2 px-4 bg-kaz-orange w-[70%] text-sm text-white border border-kaz-orange rounded-t-lg rounded-bl-lg whitespace-pre-wrap">{{ msg.message }}</span>
                      </div>
                    }
                    @if (!isOwnMsg(msg.senderUserId)) {
                      <span
                      class="flex py-2 px-4 bg-[#FEFEFE] w-[70%] text-sm text-kaz-black border border-[#F1F1F1] rounded-t-lg rounded-br-lg whitespace-pre-wrap">{{ msg.message }}</span>
                    }
                  </div>
                }
              </div>
              <!-- Message-Input -->
              <div class="absolute bottom-0 left-0  flex-row gap-4 w-full bg-[#FAFAFA] p-4 items-center"
                [class]="activeChat === null ? 'hidden' : 'flex'">
                <textarea [(ngModel)]="msg"
                  class="px-4 pt-3 h-12 grow leading-6 resize-none text-base text-[#161D26] font-medium border border-[#999999] rounded-[6px] bg-[#F7F7F7]"
                placeholder="Nachricht"></textarea>
                <fa-icon (click)="sendMessage()" class="flex px-3 py-3 cursor-pointer rounded-md hover:text-kaz-blue hover:bg-kaz-blue/10" icon="paper-plane-top" size="xl"></fa-icon>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  }
